import { apiAuthClient } from 'shared/api/lib';

import type {
  DeleteAuthLogoutRequestType,
  DeleteAuthLogoutResponseType,
} from '../types';

export const deleteAuthLogout = async ({
  headers,
}: DeleteAuthLogoutRequestType) => {
  const url = '/api/v2/auth/logout';

  const { data } = await apiAuthClient.delete<DeleteAuthLogoutResponseType>(
    url,
    { headers, params: { dontRetry: true } },
  );

  return data;
};
